import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class FulfillmentStepRelationsTableRowComponent implements IController {

  relation: any;
  step: any;

  public source: any;

  constructor() {
  }

  $onInit() {
    // this.source = this.relation.relationType === 'Blocking' ?
    //   _.find(this.relation.sourceReferencesExpanded, (s) => {return s.id === this.step.id}) :
    //   _.find(this.relation.targetReferencesExpanded, (s) => {return s.id === this.step.id});

    this.source = _.includes(this.relation.sourceIds, this.step.id) ?
      this.relation.targetReferencesExpanded[0] :
      this.relation.sourceReferencesExpanded[0]
  }


}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepRelationsTableRow', {
    bindings: {
      relation: '<',
      step: '<'
    },
    template: require('./fulfillment-step-relations-table-row.html').default,
    controller: FulfillmentStepRelationsTableRowComponent
  });
